import SlackLinkPage from '@gokrew/ui/components/SlackLinkPage';
import { TeamsLogo } from '@gokrew/ui/components/TeamsLogo';
import { TranslationNS } from '@gokrew/models/constants';
import { linkTeamsAdminAccount } from '@/api/teams-bot';
import { useAuth } from '@/context/AuthContext';
import { TEAMS_TOKEN_KEY } from './teams-token-key';

/** Admin half of the Teams account-link deep link. */
export default function AdminTeamsLinkPage() {
  const { companyId, companyName, selectedCompany } = useAuth();

  return (
    <SlackLinkPage
      onLink={(token) => linkTeamsAdminAccount(companyId!, token)}
      dashboardPath="/dashboard"
      i18nPrefix="adminTeamsLink"
      namespace={TranslationNS.teams}
      tokenKey={TEAMS_TOKEN_KEY}
      teamsPopupAware
      confirmFirst
      logo={<TeamsLogo size={45} />}
      companyName={companyName}
      companyLogoUrl={selectedCompany?.logo ?? null}
    />
  );
}
